module.exports = __webpack_public_path__ + "media/images/tools/revenues-blured-c1fdc610f237c1188884d32e487974e6.jpg";